var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-gray-50 flex justify-between px-6 py-5" },
    [
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          { staticClass: "mr-4" },
          [_c("Skeleton", { attrs: { width: 63, height: 38 } })],
          1
        ),
        _c(
          "div",
          [
            _c("Skeleton", {
              staticClass: "mb-2",
              attrs: { width: 120, height: 18 },
            }),
            _c("Skeleton", { attrs: { width: 280, height: 18 } }),
          ],
          1
        ),
      ]),
      _c("div", [_c("Skeleton", { attrs: { width: 83, height: 48 } })], 1),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }